<template>
  <div class="public" :class="{'active':publicItemList.length > 0}">
    <div class="public--header">
      <div class="public--header--title">
        <div class="title--back iconfont" @click="$router.push('/')"><span>&#xe600;</span></div>
        <div class="title--text">客户公海</div>
        <div class="title--add iconfont"><span v-if="false">&#xe602;</span></div>
      </div>
      <div class="market--search--layer">
        <div class="search--header">
          <input type="text" placeholder="请输入客户名称" class="search--header--ipt" v-model="cusName">
          <div class="search--header--icon iconfont" @click="handleToPublicSearchCusname">&#xe605;</div>
        </div>
      </div>
    </div>
    <div class="header-line"></div>
    <div class="public--content" v-if="publicItemList.length>0">
      <div
        class="public--content--item"
        v-for="item in publicItemList"
        :key="item.id"
        @click="handleToPublicDetail(item.id)"
      >
        <div class="item--title">{{item.cusName}}</div>
        <div class="item--info">
          <div class="item--text">
            <div class="item-desc">最新阶段:<span>{{item.matterPhaseName}}</span></div>
            <div class="item-desc">跟进时间:<span>{{ (item.recordDate !== '0')?item.recordDate:'暂无跟进时间'}}</span></div>
            <div class="item-desc">跟进人:<span class="desc__span">{{item.actornames}}</span></div>
            <div class="item-desc">创建时间:<span>{{item.inputDate}}</span></div>
          </div>
          <div class="item--icon">
            <div class="item--icon--desc iconfont" @click.stop="handleToDisplayPublicTel(item.mmContactsList)">
              &#xe7b5;
<!--              <a href="tel:64377718">&#xe7b5;</a>-->
            </div>
            <div class="item--icon--desc iconfont" v-if="false">&#xe622;</div>
          </div>
        </div>
      </div>
    </div>
    <div class="public--content" v-else>
      <van-empty description="暂无数据" />
    </div>
    <div class="public--search--layer" v-if="searchPublicFlag">
      <div class="search--header">
        <input type="text" placeholder="请输入客户名称" class="search--header--ipt" v-model="cusName">
        <div class="search--header--icon iconfont" @click="handleToPublicSearchCusname">&#xe605;</div>
        <div class="search--header--cancel" @click="handleToPublicCancelSearch">取消</div>
      </div>
    </div>
    <div class="public--filter--layer" v-if="false">
      <div class="filter--stage">
        <div class="filter--stage--title">跟进阶段</div>
        <div class="filter--stage--item">
          <div class="item">首次营销跟进</div>
          <div class="item">跟进中</div>
          <div class="item">审判中</div>
          <div class="item">授信通过</div>
          <div class="item">授信未通过</div>
          <div class="item">暂无合作</div>
          <div class="item">自动终结</div>
        </div>
      </div>
      <div class="filter--stage">
        <div class="filter--stage--title">跟新时间</div>
        <div class="filter--stage--item">
          <div class="item">7天内更新</div>
          <div class="item">14天内更新</div>
          <div class="item">30天内更新</div>
          <div class="item">7天未更新</div>
          <div class="item">14天未更新</div>
          <div class="item">30天未更新</div>
        </div>
      </div>
      <div class="filter--stage">
        <div class="filter--stage--title">客户来源</div>
        <div class="filter--stage--item">
          <div class="item">自主营销</div>
          <div class="item">领导推荐</div>
          <div class="item">银行推荐</div>
          <div class="item">中介推荐</div>
          <div class="item">老客户推荐</div>
          <div class="item">其他</div>
        </div>
      </div>
      <div class="filter--stage">
        <div class="filter--stage--title">所属行业</div>
        <div class="filter--stage--item">
          <div class="item">战新行业</div>
          <div class="item">其他</div>
        </div>
      </div>
      <div class="filter--btn">
        <div class="filter--btn--clear">
          清空条件
        </div>
        <div class="filter--btn--clear">
          确认
        </div>
      </div>
    </div>
    <div class="public--create--layer" v-if="false">
      <div class="create--content">
        <div class="create--item">
          <div class="item">
            <div class="create--text active">最新更新</div>
            <div class="create--text iconfont active">&#xe621;</div>
          </div>
          <div class="item">
            <div class="create--text">最新创建</div>
            <div class="create--text iconfont">&#xe621;</div>
          </div>
        </div>
        <div class="create--close iconfont">&#xe606;</div>
      </div>
    </div>
    <van-popup
      v-model="vanPublicShow"
      closeable
      position="bottom"
      :style="{ height: '30%' }"
    >
      <div
        class="public--tel"
        v-for="contractItem in mmContactsList"
        :key="contractItem.id"
        @click="handleToPublicCallTel(contractItem.contactPhone)"
      >
        <div class="public--tel--name">{{contractItem.contactName}}</div>
        <div class="public--tel--num">{{contractItem.contactPhone}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script type="text/ecmascript-6">
import { get } from '../api/api'
import recordPageTime from '../mixin/minin'
export default {
  name: 'Public',
  data () {
    return {
      pageNum: 1, // 获取营销事项列表从那一条开始
      pageSize: 10, // 获取营销事项列表一共多少条
      cusName: '', // 搜索指定客户
      matterName: '', // 筛选
      publicItemList: [], // 营销信息列表
      publicItemTotal: '', // 营销信息列表总数
      mmContactsList: [], // 联系人信息
      searchPublicFlag: false, // 控制搜索框显示
      vanPublicShow: false, // 控制电话显示
      scrollNum: 50, // 滑动到底部提前控制触发的数值
      scrollPublicFlag: true // 控制滑动pageNum在没有返回值的时候不能加1
    }
  },
  beforeMount () {
    this.getPublicList()
  },
  mounted () {
    // const publicContentElement = document.body
    window.addEventListener('scroll', this.handleToPublicListScroll, true)
  },
  destroyed () {
    // const publicContentElement = document.body
    window.removeEventListener('scroll', this.handleToPublicListScroll, true)
  },
  methods: {
    // 获取公海客户列表
    async getPublicList () {
      const result = await get('/api/CBMS-APP/mmMarketMatter/publist', {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        cusName: this.cusName,
        matterName: this.matterName
      })
      if (result.success) {
        this.publicItemList = this.publicItemList.concat(result.data.records)
        this.publicItemTotal = result.data.total
      } else {
        this.$toast.success('获取数据出错')
      }
    },
    // 滑动到底部触发事件加载更多数据
    async handleToPublicListScroll (e) {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight + this.scrollNum >= scrollHeight) {
        if (this.publicItemList.length < this.publicItemTotal && this.scrollPublicFlag) {
          this.pageNum = this.pageNum + 1
          this.scrollPublicFlag = false
          const result = await get('/api/CBMS-APP/mmMarketMatter/publist', {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            cusName: this.cusName,
            matterName: this.matterName
          })
          if (result.success) {
            this.scrollPublicFlag = true
            this.publicItemList = this.publicItemList.concat(result.data.records)
            this.publicItemTotal = result.data.total
          } else {
            this.$toast.success('获取数据出错')
          }
        } else if (this.publicItemList.length === this.publicItemTotal) {
          this.scrollNum = 0
          this.$toast.success('数据已全部加载')
        }
      }
    },
    // 弹出拨打电话页面
    handleToDisplayPublicTel (itemList) {
      this.vanPublicShow = true
      this.mmContactsList = itemList
    },
    // 打电话
    handleToPublicCallTel (contactPhone) {
      window.location.href = `tel://${contactPhone}`
    },
    // 跳转到客户详情
    handleToPublicDetail (id) {
      this.$router.push({ name: 'ViewMarket', params: { id, routerName: 'public', routeTag: 'public' } })
    },
    // 条件过滤
    handleToPublicFiler (filterVal) {
      if (filterVal === 'cusName') {
        document.body.style.overflow = 'hidden'
        this.searchPublicFlag = true
      } else {
        this.$toast.success('功能暂未上线')
      }
    },
    // 根据搜索内容过滤条件
    handleToPublicSearchCusname () {
      // document.body.style.overflow = 'auto'
      // this.searchPublicFlag = false
      this.publicItemList = []
      this.publicItemTotal = ''
      this.getPublicList()
    },
    // 取消内容过滤
    handleToPublicCancelSearch () {
      document.body.style.overflow = 'auto'
      this.searchPublicFlag = false
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.public
  position : relative
  width : 100vw
  height : 100vh
  overflow-x : hidden
  overflow-y : scroll
  &.active
    padding-bottom : 64px
  .public--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .public--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      padding : 0 16px
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--back
        flex : 1
        text-align : left
        span
          font-size : 42px
          padding : 0 16px
      .title--text
        flex : 1
        text-align : center
      .title--add
        flex : 1
        text-align : right
        span
          font-size : 42px
          padding : 0 16px
    .market--search--layer
      .search--header
        padding : 16px 16px 0 16px
        display : flex
        background-color : #faf9f9
        font-family: MyriadPro-Regular
        font-size: 34px
        font-weight: normal
        font-stretch: normal
        color : #4282e1
        .search--header--ipt
          padding : 16px 0 16px 16px
          flex : 1
          height : 34px
          outline: none
          -webkit-appearance: none
          border-radius:0
          border-top : 1px solid #8e8c8c
          border-bottom : 1px solid #8e8c8c
          border-left :  1px solid #8e8c8c
          border-right :  1px solid #8e8c8c
          border-top-left-radius : 12px
          border-bottom-left-radius : 12px
        .search--header--icon
          width : 100px
          height : 34px
          background-color : #faf9f9
          text-align : center
          padding : 16px 16px 16px 16px
          font-size: 34px
          border-top : 1px solid #8e8c8c
          border-bottom : 1px solid #8e8c8c
          border-right :  1px solid #8e8c8c
          border-left :  1px solid #8e8c8c
          border-top-right-radius : 12px
          border-bottom-right-radius : 12px
  .header-line
    height : 170px
    width : 100%
  .public--content
    .public--content--item
      margin : 16px 16px 0 16px
      border : 2px solid #f7f7f7
      border-radius : 12px
      .item--title
        padding : 16px
        font-family: MyriadPro-Regular
        font-size: 34px
        font-weight: normal
        font-stretch: normal
        color : #4282e1
      .item--info
        display : flex
        .item--text
          flex : 1
          .item-desc
            padding : 8px 0 8px 32px
            font-family: MyriadPro-Regular
            font-size: 28px
            font-weight: normal
            font-stretch: normal
            color: #333333
            span
              padding-left : 24px
              &.desc__span
                padding-left : 50px
        .item--icon
          width : 150px
          display : flex
          flex-direction : column
          align-items : center
          .item--icon--desc
            transform : translateY(25%)
            flex : 1
            font-size : 38px
            font-family: MyriadPro-Regular
            font-weight: normal
            font-stretch: normal
            color : #4282e1
            a
              text-decoration : none
              color : #4282e1
  .public--tel
    display : flex
    align-items : center
    margin-top : 32px
    font-family: MyriadPro-Regular
    font-size: 28px
    font-weight: normal
    font-stretch: normal
    color : #4282e1
    &:nth-child(1)
      margin-top : 80px
    .public--tel--name
      flex : 1
      padding : 16px 0
      text-align : center
    .public--tel--num
      flex : 1
      padding : 16px 0
      text-align : left
  .public--filter--layer
    position : absolute
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : #f7f7f7
    z-index : 11
    overflow : scroll
    .filter--stage
      margin-top : 16px
      padding-bottom : 16px
      border-bottom : 1px solid #8b8787
      .filter--stage--title
        padding : 16px
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color : #4282e1
      .filter--stage--item
        margin : 0 16px
        display : flex
        flex-wrap : wrap
        font-size: 28px
        .item
          width : calc((100% - 96px)/4)
          margin-left : 8px
          margin-top : 8px
          padding : 16px 8px
          height : 66px
          text-align : left
          background-color : #ffffff
    .filter--btn
      margin-top : 64px
      display : flex
      .filter--btn--clear
        margin : 0 10%
        padding : 24px 16px
        flex : 1
        text-align : center
        background-color : #4282e1
        color : #ffffff
        border-radius : 12px
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
  .public--create--layer
    position : absolute
    top: 0
    left: 0
    right : 0
    bottom : 0
    background-color : rgba(0,0,0,0.5)
    z-index : 11
    overflow : hidden
    .create--content
      position : absolute
      left :0
      bottom : 0
      width : 100vw
      height : 40vh
      background-color : #ffffff
      border-top-right-radius : 16px
      border-top-left-radius : 16px
      .create--item
        position : absolute
        top: 50%
        left:50%
        transform : translate(-50%,-50%)
        width : 100%
        .item
          display : flex
          padding : 24px 0
          margin : 0 36px
          justify-content : space-between
          border-bottom : 1px solid #b6b5b5
          .create--text
            font-family: MyriadPro-Regular
            font-size: 32px
            font-weight: normal
            font-stretch: normal
            color : #333333
            &.active
              color : #4282e1
      .create--close
        position : absolute
        right : 12px
        top: 12px
        padding : 16px
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color : #333333
</style>
